import { ContextService } from "./context.service";
import { Configuration } from "../../../shared/models/configuration.model";
import { Organization } from "../../../shared/models/organization.model";

/***
 * This is the local backend implementation that uses the downloaded metadata to get data.
 */
export class ContextServiceLocal implements ContextService {
    public getConfiguration = async (
        _site: string,
        _id: string,
    ): Promise<Configuration> => {
        // Local downloads should not use configurations
        return {
            organizationId: "",
            site: "",
            name: "",
            properties: {},
            custom: {},
            system: {},
            validity: ""
        };
    }
    public getOrganization = async (
        _site: string,
        _id: string,
    ): Promise<Organization> => {
        // Local downloads should not use organizations
        return { site: "", name: "", properties: {}, custom: {}, system: {}, validity: "" };
    }

}
